import { render, staticRenderFns } from "./ResetPasswordStaff.vue?vue&type=template&id=fb8ad4a0&"
import script from "./ResetPasswordStaff.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports